/**
 * Multi-line shipping address for clipboard (name, street, city/state/pin, country).
 */
export const formatShippingAddressForCopy = (address = {}) => {
  const name = [address.firstName, address.lastName].filter(Boolean).join(' ');
  const cityState = [address.city, address.state].filter(Boolean).join(', ');
  const cityStateZip = cityState
    ? `${cityState}${address.zipcode ? ` - ${address.zipcode}` : ''}`
    : address.zipcode || '';

  return [name, address.street, cityStateZip, address.country]
    .filter((line) => line !== undefined && line !== null && String(line).trim() !== '')
    .join('\n');
};

export const copyTextToClipboard = async (text) => {
  const value = String(text ?? '');
  if (!value) {
    throw new Error('Nothing to copy');
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};
